module.exports = __webpack_public_path__ + "img/slide7.d30b579c.png";